import React, { lazy } from 'react';
import { Switch, Redirect } from 'react-router-dom';

import { roles } from 'utility/constants/roles';

import RoleRestrictedRoute from 'utility/routing/RoleRestrictedRoute';
import { useSelector } from 'react-redux';
import { isBasketAdmin as getIsBasketAdmin } from 'modules/auth';

const HomePage = lazy(() => import('containers/pages/Home'));

const HomeRouter = () => {
	const isBasketAdmin = useSelector(getIsBasketAdmin);

	if (isBasketAdmin) {
		return <Redirect to="/shop/marketplace/admin-packages" />;
	}

	return (
		<Switch>
			<RoleRestrictedRoute
				exact
				path="/"
				component={HomePage}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
		</Switch>
	);
};

export default HomeRouter;
